module.exports = __webpack_public_path__ + "static_pc/img/s04.1f6dc816.png";